import { Helmet } from "react-helmet-async";

const defaultSEO = {
  title: "AGRABAT Sénégal | Agglos, Parpaings, Granulats de Silex, Béton",
  description: "AGRABAT - Fabricant et fournisseur d'agglos, parpaings, briques, granulats de silex et matériaux de construction au Sénégal. Livraison Dakar, Thiès, Gambie.",
  keywords: "agglo, agglos, parpaing, parpaings, brique, briques, béton, granulats, silex, cailloux, roche, matériaux construction, Sénégal, Thiès, Dakar",
  image: "https://customer-assets.emergentagent.com/job_agglos-producer/artifacts/zs2rc3fd_10.png",
  url: "https://agrabat.sn",
};

export default function SEO({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = "website"
}) {
  const seoTitle = title ? `${title} | AGRABAT Sénégal` : defaultSEO.title;
  const seoDescription = description || defaultSEO.description;
  const seoKeywords = keywords || defaultSEO.keywords;
  const seoImage = image || defaultSEO.image;
  const seoUrl = url || defaultSEO.url;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:type" content={type} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      
      {/* Canonical */}
      <link rel="canonical" href={seoUrl} />
    </Helmet>
  );
}
